import React, { PureComponent } from "react";
import classnames from "classnames";
import { injectIntl } from "react-intl";

import "./Activity.css";

import { OnIcon, InfoIcon } from "./Icons";

const activityWithImage = ["ALPIN", "JARALP", "RAQU", "SNOW"];

const getImage = normalizedCode => {
  if (activityWithImage.includes(normalizedCode)) {
    return "/images/activities/" + normalizedCode + ".svg";
  }
  return "/images/activities/ALPIN.svg";
};

export default injectIntl(
  class Activity extends PureComponent {
    touched = code => e => {
      const { onChanged } = this.props;
      onChanged(code);
    };

    render() {
      const {
        intl,
        name,
        normalizedCode,
        code,
        comment,
        selected
      } = this.props;
      const outerClasses = classnames("cm-activity--outer", {
        "cm-activity--outer__selected": selected
      });

      const infoClasses = classnames("cm-activity--info", {
        "cm-activity--info__hidden": comment === undefined
      });

      return (
        <div className={outerClasses} onClick={this.touched(code)}>
          <InfoIcon className={infoClasses} />
          <div className="cm-activity--marker">
            <OnIcon className="cm-activity--icon" />
          </div>
          <div className="cm-activity--picto">
            <img src={getImage(normalizedCode)} alt={name} />
          </div>
          <div className="cm-activity--text">
            <div>{intl.messages.group_classes}</div>
            <div className="cm-activity--name">{name}</div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Activity.js